import * as React from 'react';
import Helmet from 'react-helmet';

import { Component, ComponentProps, deps, inject, observer } from '../lib/component';
import { classes } from 'typestyle';
import DownArrow from '../static/expand_more.png';
import LickdLogo from '../static/lickd_logo.svg';
import { ButtonPill } from '../components/button-pill';
import { Head } from './head';

import styles from '../styles/marketing-pages';
import PrismicDOM from 'prismic-dom';

@inject(deps)
@observer
export class LightweightLandingPage extends Component<ComponentProps> {
  searchSuffix: string;

  constructor(props) {
    super(props);
    this.searchSuffix = this.props.model.router.location.search.substr(1);
  }

  render(): JSX.Element | false | null {
    const model = this.props.model.page.lightweightLanding;
    const ctaUrl = `/?show-sign-up&${this.searchSuffix}`;

    const customHeaderImage = model.customHeaderImage
      ? {
          backgroundImage: `url(${model.customHeaderImage})`,
        }
      : {};

    return (
      <div className={styles.background}>
        <Head />
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
        <div className={styles.container}>
          <div
            className={classes(styles.hero, model.customHeaderImage ? 'without-gradient' : 'with-gradient')}
            style={customHeaderImage}
          >
            <div className={styles.logos}>
              <img src={LickdLogo} />
            </div>
            <div className={styles.heroInner}>
              <div className={styles.heroInnerText}>{model.headerText}</div>
              <ButtonPill href={ctaUrl} primary={false}>
                {model.ctaText}
              </ButtonPill>
            </div>
            <div className={styles.readMore}>
              <div>Read more</div>
              <img src={DownArrow} width="12" height="8" />
            </div>
          </div>
          <div className={styles.content}>
            <h4>{model.bodyTitle}</h4>
            <div className={styles.contentMain}>
              {model.bodyContent.map((column, index) => (
                <div key={index} dangerouslySetInnerHTML={{ __html: PrismicDOM.RichText.asHtml(column) }}></div>
              ))}
            </div>
            <div className={styles.downloadCta}>
              <ButtonPill href={ctaUrl} primary={false}>
                {model.ctaText}
              </ButtonPill>
            </div>
            <h4>{model.featuredTitle}</h4>
            <div className={styles.hottestTracks}>
              {model.featured.map((feature) => (
                <div className={classes(styles.artist)} key={feature.image}>
                  <a href={ctaUrl}>
                    <div>
                      <img src={LickdLogo} />
                      <div className={styles.artistImage} style={{ backgroundImage: `url('${feature.image}')` }}>
                        <div className={styles.artistName}>
                          <div>{feature.name}</div>
                          {feature.subtext}
                        </div>
                      </div>
                    </div>
                  </a>
                  {feature.description}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
